<template>
  <b-navbar
    toggleable="lg"
    type="light"
    variant="light"
  >
    <b-container>
      <b-navbar-brand
        class="text-green"
        to="/Home"
      >
        <b>
          旅遊學庫商店管理
        </b>
      </b-navbar-brand>

      <!-- Right aligned nav items -->
      <b-navbar-nav class="ml-auto">
        <b-nav-item
          title="登出"
          class="text-green"
          @click="logout"
        >
          <!-- Using 'button-content' slot -->
          <em><i class="fa fa-user-circle-o">&ensp;{{ username }}</i></em>&thinsp;
          <i class="fa fa-sign-out" />
          <!-- Message End -->
        </b-nav-item>
      </b-navbar-nav>
    </b-container>
  </b-navbar>
</template>

<script>
export default {
  name: 'Header',
  data () {
    return {
    }
  },
  computed: {
    username () {
      const user = this.$store.state.Auth
      if (!user.user) {
        return ''
      }
      return user.username
    }
  },
  methods: {
    logout () {
      return this.$store.dispatch('Auth/logout')
        .then(() => {
          this.$router.push({ name: 'Login' })
        })
        .catch(err => this.throwReject(err))
    }
  }
}
</script>
<style scoped>
.text-green > a {
  text-decoration: none !important;
  color: #415050 !important;
}
</style>
